import { j as e } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as c } from "react";
import { I as s } from "../../../../IconBase-CxZyIWw2.js";
const l = c((o, t) => /* @__PURE__ */ e.jsx(
  s,
  {
    ref: t,
    ...o,
    image: (r) => /* @__PURE__ */ e.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        fill: "none",
        viewBox: "0 0 48 48",
        ...r,
        children: /* @__PURE__ */ e.jsx(
          "path",
          {
            fill: "currentColor",
            d: "M24 40c-.21 0-.4-.08-.54-.23-.04-.05-4.51-4.75-7.6-7.59C10.72 27.46 8 22.46 8 17.73 8 11.55 10.69 8 15.37 8c3.41 0 4.67 2 5.69 3.61.91 1.44 1.5 2.26 2.94 2.26 1.14 0 1.72-.77 2.65-2.14C27.78 10.07 29.18 8 32.63 8 37.52 8 40 11.35 40 17.94c0 6.66-4.86 11.21-7.47 13.65l-.39.37c-1.96 1.85-7.54 7.75-7.6 7.81-.14.15-.33.23-.54.23M15.37 9.5c-4.85 0-5.87 4.48-5.87 8.23 0 4.3 2.55 8.91 7.37 13.34 2.49 2.28 5.83 5.74 7.13 7.09 1.47-1.54 5.47-5.74 7.11-7.29l.4-.37c2.44-2.29 6.99-6.54 6.99-12.55 0-7.57-3.35-8.44-5.87-8.44-2.65 0-3.67 1.49-4.74 3.08-.93 1.37-1.9 2.79-3.89 2.79-2.34 0-3.33-1.57-4.21-2.96-.99-1.57-1.84-2.92-4.42-2.92"
          }
        )
      }
    )
  }
));
l.displayName = "AgencyHeartCompleteIcon";
export {
  l as AgencyHeartCompleteIcon,
  l as default
};
//# sourceMappingURL=index.js.map
